import script from "./OwnMultasView.vue?vue&type=script&setup=true&lang=js"
export * from "./OwnMultasView.vue?vue&type=script&setup=true&lang=js"

import "./OwnMultasView.vue?vue&type=style&index=0&id=0853a808&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0853a808"]])

export default __exports__